export const useFlags = () => ({
  // Layout
  headerSupportLinks: false,
  processingStatus: false,
  notificationBell: false,

  // Dashboard
  onboardingFlag: true,

  // Guests
  guestProfileAmount: false,
  guestListShowLatestPairedTag: false,
  guestListShowGuestId: false,
  guestViewCheckinAmount: false,

  // Products & Vouchers
  redeemableProductsOption: false,
  onlineOrder: true,

  // Locations
  locationTableManagement: true,
  mewsLinkOutlet: true,

  // Bookings
  bookingPage: false,
  bookingListImprovement: false,

  // End of Day
  eodUnsyncedTransactionWarningFlag: false,
  eodIgnoreUnignoreAllShifts: true,

  // Settings
  accountMapping: false,
  chartOfAccounts: false,
  integrationsSetting: false,
  taxCodeFlag: false,
  // MEWS inputs: account selects (Revenue/COGS, Inventory, Credits Liability, Tax),
  // MEWS tax code checkbox, and Link Location on the location and category forms
  mewsAccountFields: false,

  // Integrations
  cloudbedsAllowAccessModal: false,
  purchaseplusAllowAccessModal: false,
  purchaseplusFlag: false,

  cloudbedsIntegration: true,

  // Filters
  filterMenuOpen: false,

  // Shifts
  closeShift: true,
});

export default useFlags;
